import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import { useAppStore } from "@/store/appContext";

const ThankYouModal: React.FC = () => {
  const {
    showConfetti,
    setShowConfetti,
    clearLocalCart,
    closeConfirmationSheet,
    triggerResetProductDropdowns,
    refreshProducts,
  } = useAppStore();
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (showConfetti) {
      // Clear local cart when showing thank you
      clearLocalCart();

      // Reset product dropdowns to default values
      triggerResetProductDropdowns();

      // Refresh products to reload the product grid
      refreshProducts();

      // Auto-close after 5 seconds
      const timer = setTimeout(() => {
        setShowConfetti(false);
        closeConfirmationSheet();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [
    showConfetti,
    clearLocalCart,
    triggerResetProductDropdowns,
    refreshProducts,
    setShowConfetti,
    closeConfirmationSheet,
  ]);

  if (!showConfetti) return null;

  return (
    <div className="thank-you-modal-overlay">
      <Confetti
        width={windowDimensions.width}
        height={windowDimensions.height}
        recycle={false}
        numberOfPieces={200}
        gravity={0.3}
        initialVelocityY={20}
        colors={["#10b981", "#3b82f6", "#f59e0b", "#ef4444", "#8b5cf6"]}
      />

      <div className="thank-you-modal" onClick={(e) => e.stopPropagation()}>
        <div className="thank-you-content">
          <div className="thank-you-icon">🎉</div>
          <h2 className="thank-you-title">Thank You!</h2>
          <p className="thank-you-message">
            Your donation has been initiated successfully!
          </p>
          <p className="thank-you-instruction">
            Please complete the payment on your device to finalize your
            donation.
          </p>
          <div className="thank-you-timer">
            <p>This window will close automatically in 5 seconds...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
